const points = [
  {
    icon: "ri-star-smile-fill",
    title: "甄选口碑佳作",
    desc: "由编辑与读者共同把关，只推荐真正值得一读的作品。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-list-check-3",
    title: "科学的分类体系",
    desc: "40+ 题材标签与题材分类，帮你精准找到对味的作品。",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-timer-flash-fill",
    title: "动态实时同步",
    desc: "新作连载与完结动态第一时间更新，追更不再错过。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-newspaper-line",
    title: "深度原创内容",
    desc: "漫评盘点与创作干货均为原创，给你真正有价值的阅读。",
    color: "bg-accent-100 text-accent-700",
  },
];

export default function BrandBand() {
  return (
    <section className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-accent-500" aria-hidden="true"></span>
              关于樱花漫画
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              为每一部好作品，
              <br />
              找到懂它的读者
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              我们相信，一部好漫画值得被更多人看见。樱花漫画由一群热爱国产漫画的编辑与读者共同维护，坚持客观评分、真实口碑与原创内容，致力于成为你追漫路上最贴心的伙伴。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              无论你是刚入坑的新人，还是追了多年的老读者，这里总有能打动你的故事。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {points.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-300/60 bg-background-50 p-6"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${p.color}`}>
                  <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}